import { auth, facebookProvider, db } from '../../firebase';
import { GetCartData, GetAddress } from '../actions';
import axios from 'axios';
import { API } from '../../constants';

const createAction = name => ({
    //// Handle event
    OPEN_DIALOG_LOGIN: `${name}_OPEN_DIALOG_LOGIN`,
    CLOSE_DIALOG_LOGIN: `${name}_CLOSE_DIALOG_LOGIN`,
    FORM_CHANGE: `${name}_FORM_CHANGE`,
    //// Login with Facebook
    FIREBASE_FACEBOOK_AUTH_PENDING: `${name}_FIREBASE_FACEBOOK_AUTH_PENDING`,
    FIREBASE_FACEBOOK_AUTH_SUCCESS: `${name}_FIREBASE_FACEBOOK_AUTH_SUCCESS`,
    FIREBASE_FACEBOOK_AUTH_FAILED: `${name}_FIREBASE_FACEBOOK_AUTH_FAILED`,
    //// Login with Email and Password
    FIREBASE_AUTH_PENDING: `${name}_FIREBASE_AUTH_PENDING`,
    FIREBASE_AUTH_SUCCESS: `${name}_FIREBASE_AUTH_SUCCESS`,
    FIREBASE_AUTH_FAILED: `${name}_FIREBASE_AUTH_FAILED`,
    //// Register new user
    FIREBASE_REGISTER_USER: `${name}_FIREBASE_REGISTER_USER`,
    //// Update profile
    UPDATE_PROFILE_PENDING: `${name}_UPDATE_PROFILE_PENDING`,
    UPDATE_PROFILE_SUCCESS: `${name}_UPDATE_PROFILE_SUCCESS`,
    UPDATE_PROFILE_FAILED: `${name}_UPDATE_PROFILE_FAILED`,
    //// User session login
    FIREBASE_AUTH_CURRENT_USER: `${name}_FIREBASE_AUTH_CURRENT_USER`,
    //// Check user is linked SF Plus
    FIREBASE_SF_PLUS_PENDING: `${name}_FIREBASE_SF_PLUS_PENDING`,
    FIREBASE_SF_PLUS_SUCCESS: `${name}_FIREBASE_SF_PLUS_SUCCESS`,
    FIREBASE_SF_PLUS_FAILED: `${name}_FIREBASE_SF_PLUS_FAILED`,
    //// Sign out
    FIREBASE_AUTH_SIGNOUT: `${name}_FIREBASE_AUTH_SIGNOUT`,
    //// Reset email
    FIREBASE_RESET_EMAIL_PENDING: `${name}_FIREBASE_RESET_EMAIL_PENDING`,
    FIREBASE_RESET_EMAIL_SUCCESS: `${name}_FIREBASE_RESET_EMAIL_SUCCESS`,
    FIREBASE_RESET_EMAIL_FAILED: `${name}_FIREBASE_RESET_EMAIL_FAILED`,
    //// Check balance from vista
    SF_PLUS_CHECK_BALANCE_PENDING: `${name}_SF_PLUS_CHECK_BALANCE_PENDING`,
    SF_PLUS_CHECK_BALANCE_SUCCESS: `${name}_SF_PLUS_CHECK_BALANCE_SUCCESS`,
    SF_PLUS_CHECK_BALANCE_FAILED: `${name}_SF_PLUS_CHECK_BALANCE_FAILED`
});

export const LOGIN = createAction('LOGIN');

export const OpenDialogLogin = () => dispatch => {
    dispatch({ type: LOGIN.OPEN_DIALOG_LOGIN });
};

export const CloseDialogLogin = () => dispatch => {
    dispatch({ type: LOGIN.CLOSE_DIALOG_LOGIN });
};

export const FormChange = formType => dispatch => {
    dispatch({
        type: LOGIN.FORM_CHANGE,
        payload: formType
    });
};

export const SignInWithFacebook = () => async dispatch => {
    dispatch({ type: LOGIN.FIREBASE_FACEBOOK_AUTH_PENDING });

    try {
        const response = await auth.signInWithPopup(facebookProvider);

        AddDataUser(response)
            .then(res => {
                dispatch({
                    type: LOGIN.FIREBASE_FACEBOOK_AUTH_SUCCESS,
                    payload: res
                });
        
                localStorage.setItem('Hello', true);
        
                dispatch(GetCartData());
        
                dispatch(GetAddress());
            })
            .catch(err => err)

    } catch (error) {
        dispatch({
            type: LOGIN.FIREBASE_FACEBOOK_AUTH_FAILED,
            error
        });
    }
};

const AddDataUser = async ({ user }) => {
    
    await axios
        .post(API.CREATE_CUSTOMER, { id: user.uid }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.data)
        .catch(error => Promise.reject(error));

    return {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email
    };

}

export const SignWithEmainAndPassword = (email, password) => async dispatch => {
    dispatch({ type: LOGIN.FIREBASE_AUTH_PENDING });

    try {
        const response = await auth.signInWithEmailAndPassword(email, password);

        AddDataUser(response)
            .then(res => {
                dispatch({
                    type: LOGIN.FIREBASE_AUTH_SUCCESS,
                    payload: res
                });
            
                localStorage.setItem('Hello', true);
            
                dispatch(GetCartData());
            
                dispatch(GetAddress());
            })
            .catch(err => err)

    } catch (error) {
        dispatch({
            type: LOGIN.FIREBASE_AUTH_FAILED,
            error
        });
    }
};

export const CreateUserWithEmailAndPassword = (rgtEmail, rgtPassword, rgtName, rgtLName) => async dispatch => {
    dispatch({ type: LOGIN.FIREBASE_AUTH_PENDING });
    try {
        const response = await auth.createUserWithEmailAndPassword(rgtEmail, rgtPassword);

        AddDataUser(response)
            .then(user => {
                const currentUser = {
                    uid: user.uid,
                    email: user.email,
                    displayName: user.displayName
                };
        
                dispatch({
                    type: LOGIN.FIREBASE_REGISTER_USER,
                    payload: currentUser
                });
        
                dispatch(UpdateProfile(rgtName, rgtLName));
        
                localStorage.setItem('Hello', true);
        
                dispatch(GetCartData());
        
                dispatch(GetAddress());
            })


    } catch (error) {
        dispatch({
            type: LOGIN.FIREBASE_AUTH_FAILED,
            error
        });
    }
};

export const UpdateProfile = (name, lname) => dispatch => {
    dispatch({ type: LOGIN.UPDATE_PROFILE_PENDING });

    let user = auth.currentUser;

    user.updateProfile({ displayName: `${name} ${lname}` })
        .then(() =>
            dispatch({
                type: LOGIN.UPDATE_PROFILE_SUCCESS,
                payload: {
                    uid: user.uid,
                    email: user.email,
                    displayName: user.displayName
                }
            })
        )
        .catch(error => dispatch({ type: LOGIN.UPDATE_PROFILE_FAILED, error }));
};

export const FirebaseAuthCurrentUser = () => dispatch => {
    dispatch({ type: LOGIN.FIREBASE_AUTH_PENDING });
    auth.onAuthStateChanged(user => {
        if (user) {
            const currentUser = {
                uid: user.uid,
                displayName: user.displayName,
                email: user.email
            };

            dispatch({
                type: LOGIN.FIREBASE_AUTH_CURRENT_USER,
                payload: currentUser
            });

            localStorage.setItem('Hello', true);
            
            dispatch(GetCartData());
            
        } else {
            dispatch({
                type: LOGIN.FIREBASE_AUTH_FAILED,
                error: null
            });
        }
    });
};

export const FirebaseSfPlusUser = () => async (dispatch, getState) => {
    dispatch({ type: LOGIN.FIREBASE_SF_PLUS_PENDING });
    try {
        const { firebaseAuth } = getState().login;

        const result = await db
            .ref(`/users/${firebaseAuth.uid}`)
            .once('value')
            .then(snapshot => {
                const member = snapshot.val() && snapshot.val().sf_movie_club;
                return member;
            })
            .catch(error => Promise.reject(error));

        dispatch({
            type: LOGIN.FIREBASE_SF_PLUS_SUCCESS,
            payload: result
        });

        dispatch(SFPlusCheckBalance(result.card_no));
    } catch (error) {
        dispatch({
            type: LOGIN.FIREBASE_SF_PLUS_FAILED,
            error
        });
    }
};

export const FirebaseForgetPassword = email => dispatch => {
    dispatch({ type: LOGIN.FIREBASE_RESET_EMAIL_PENDING });
    auth.sendPasswordResetEmail(email)
        .then(() => {
            dispatch({
                type: LOGIN.FIREBASE_RESET_EMAIL_SUCCESS,
                payload: {
                    message: `We've sent an email to ${email} Click the link in the email to reset your password.`
                }
            });
        })
        .catch(error => {
            dispatch({
                type: LOGIN.FIREBASE_RESET_EMAIL_FAILED,
                error
            });
        });
};

export const FirebaseAuthSignOut = () => async dispatch => {
    await auth.signOut();
    await localStorage.removeItem('Hello');
    await dispatch({ type: LOGIN.FIREBASE_AUTH_SIGNOUT });
    window.location.href = window.location.origin;
};

export const SFPlusCheckBalance = cardNumber => async (dispatch, getState) => {
    dispatch({ type: LOGIN.SF_PLUS_CHECK_BALANCE_PENDING });
    try {
        const { language } = getState();
        const params = { cardNumber };
        const result = await axios
            .get(
                API.GET_BALANCE,
                { params },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                }
            )
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        dispatch({
            type: LOGIN.SF_PLUS_CHECK_BALANCE_SUCCESS,
            payload: result
        });
    } catch (error) {
        dispatch({
            type: LOGIN.SF_PLUS_CHECK_BALANCE_FAILED,
            error
        });
    }
};
